import { Icon } from '@manychat/icons'

import { FlowChartNextStep } from './FlowChartNextStep'

export enum ButtonAppearance {
  /**
   * Default appearance
   */
  DEFAULT = 'default',
  /**
   * Default appearance with centered text
   */
  DEFAULT_CENTERED = 'centered',
  /**
   Link-like appearance (e.q. in TT message)
   */
  TEXT = 'text',
  /**
   * Appearance for the menu button
   * (like in WA List message or WA Catalog message)
   */
  MENU = 'menu',
}

export interface FlowChartButtonStats {
  /**
   * Clicked users count.
   *
   * Used to calculate CTR
   */
  users: number | null
  /** Total clicks count */
  clicks: number | null
  /** Button users segmentId */
  segmentId: string | null
}

export interface FlowChartButton {
  id: string
  caption: string
  appearance: ButtonAppearance
  isInteractive: boolean
  nextStep: FlowChartNextStep | null
  icon: Icon | null
  stats: FlowChartButtonStats
  isFallback: boolean
}
